import type { JSX } from "react";
import NotFound from "./NotFound";
import { useAppSelector } from "@/store/hooks";
import { selectIsAdmin } from "@/store/authSlice";

interface AdminRouteProps {
  children: JSX.Element;
}

// Guards admin-only areas. Mirrors the backend AdminOnly policy: only users flagged
// IsAdmin (RBAC "Admin" role or legacy admin) may enter; everyone else is told and sent home.
export function AdminRoute({ children }: AdminRouteProps) {
  const isAdmin = useAppSelector(selectIsAdmin);
  return isAdmin ? (
    children
  ) : (
    <NotFound message="This area is restricted to administrators." />
  );
}
